export default __webpack_public_path__ + "static/media/flag.ede831f0.svg";